import { Component, Input, OnInit, inject } from '@angular/core';
import { environment } from '../../environment';
import { ENVIRONMENT_DISPLAY } from './environment-display';

@Component({
  selector: 'lib-environment-banner',
  templateUrl: './environment-banner.component.html',
  styleUrls: ['./environment-banner.component.scss'],
  standalone: false,
})
export class EnvironmentBannerComponent implements OnInit {
  @Input()
  environmentInfoText: string;

  cssClass: string;
  environmentName: string;

  private env = inject(environment);

  ngOnInit() {
    const display = ENVIRONMENT_DISPLAY[this.env.name];
    this.environmentName = display?.name;
    this.cssClass = display?.cssClass;
  }
}
